import { useState } from "react";
import { MenuItem, Stack } from "@mui/material";
import { useAuthContext } from "../../../auth/useAuthContext";
import MenuPopover from "../../../components/menu-popover";
import Iconify from "../../../components/iconify";
import { IconButtonAnimate } from "../../../components/animate";
import { setLevel } from "../../../auth/utils";

export default function LevelPopover({ handleLevelChange }) {
  const { user } = useAuthContext();

  const [openPopover, setOpenPopover] = useState(null);
  const [currentLevel, setCurrentLevel] = useState(null);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLevel = async (newLevel) => {
    setLevel(newLevel);
    setCurrentLevel(newLevel);
    handleClosePopover()
  };


  const staticLevels = [
    { id: 1, name: "Level 1" },
    { id: 2, name: "Level 2" },
  ];

  return (
    <>
      {user?.venue?.levels?.length > 1 && (
        <>
          <IconButtonAnimate
            onClick={handleOpenPopover}
            sx={{
              width: 40,
              height: 40,
              ...(openPopover && {
                bgcolor: "action.selected",
              }),
            }}
          >
            <Iconify icon="eva:pin-outline" />
          </IconButtonAnimate>

          <MenuPopover
            open={openPopover}
            onClose={handleClosePopover}
            sx={{ width: 180 }}
          >
            <Stack spacing={0.75}>
              {staticLevels.map((option) => (
                <MenuItem
                  key={option.id}
                  selected={option.id === currentLevel?.id}
                  onClick={() => handleChangeLevel(option)}
                >
                  {option.name}
                </MenuItem>
              ))}
            </Stack>
          </MenuPopover>
        </>
      )}
    </>
  );
}
